import { useLayoutEffect, useRef } from 'react';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import gsap from 'gsap';

gsap.registerPlugin(DrawSVGPlugin);

const Hero = () => {
	// DrawSVGPlugin for Marvel SVG
	const svg = useRef();
	useLayoutEffect(() => {
		gsap.set('#path', { drawSVG: 0, fill: true });
		let ctx = gsap.context(() => {
			gsap.to('.path-marvel-animation', {
				drawSVG: '100%',
				duration: 9,
				ease: 'power1.inOut',
			});

			gsap.to(
				'.path-marvel-animation',
				{
					fill: 'red',
					duration: '4',
				},
				'-=8'
			);
		}, svg);

		return () => ctx.revert();
	}, []);

	return (
		<>
			<section className="hero-wrapper">
				<div className="hero-text-wrapper">
					<div className="hero-which">which</div>
					<div className="svg-wrapper">
						<div className="svg-container">
							<svg
								ref={svg}
								className="svg-test"
								xmlns="http://www.w3.org/2000/svg"
								data-name="Calque 1"
								viewBox="0 0 60 30"
							>
								<path
									id="path"
									className="path-marvel-animation"
									fill="red"
									stroke="#fff"
									strokeWidth={'0.5px'}
									d="M4.94 10.62c-.06-.42-.19-.86-.52-1.77l-1.1-3.19c-.01-.06-.37-1.18-.41-1.27q-.13-.43-.19-.6c.07.76.12 1.74.12 2.37v2.6c0 .83.02 1.36.1 1.86H.57c.07-.54.1-1.04.1-1.86V2.51c0-.72-.04-1.35-.1-1.87h3.17c.08.52.18.9.46 1.69L6 7.5l1.79-5.17c.28-.8.37-1.19.44-1.69h3.18c-.07.58-.1 1.07-.1 1.87v6.25c0 .91.02 1.38.1 1.86H9.05c.07-.55.1-1.01.1-1.86V6.15c0-.29.04-1.19.06-1.56l.05-.82c-.26.94-.38 1.37-.54 1.8L7.56 8.86c-.3.85-.46 1.38-.52 1.76H4.95zM19.71 10.62c-.1-.58-.17-.89-.29-1.29l-.32-1.02h-3.42l-.32 1.02c-.16.48-.24.85-.3 1.29h-2.81c.18-.36.29-.65.58-1.46l2.58-7.23c.22-.59.32-.95.38-1.3h3.13c.08.35.17.66.41 1.3l2.6 7.22c.23.64.42 1.13.58 1.46H19.7zm-2.34-7.93l-1.12 3.6h2.25l-1.14-3.6zM29.4 10.62c-.07-.38-.22-.88-.59-1.87-.38-1.04-.53-1.32-.83-1.58-.25-.23-.55-.32-.94-.32h-1.22v1.97c0 .82.02 1.26.1 1.81h-2.58c.07-.55.1-.91.1-1.8V2.37c0-.74-.02-1.19-.1-1.76.53.02.97.04 1.79.04h3.12c1.94 0 3.07 1.01 3.07 2.73 0 .85-.24 1.52-.71 1.97-.3.28-.55.41-1.14.6.61.19.89.47 1.27 1.32.18.38.35.79.89 2.09.13.34.28.64.58 1.27H29.4zm-1.7-5.83c.71 0 1.14-.43 1.14-1.12s-.38-1.02-1.13-1.02h-1.88v2.13h1.87zM37.38 7.7q.1.32.23.83c.14-.53.17-.6.23-.83l1.74-5.77c.16-.55.24-.89.28-1.3h2.82c-.17.36-.28.64-.58 1.46l-2.54 7.22c-.2.59-.32 1-.38 1.29h-3.12c-.06-.31-.18-.72-.38-1.29l-2.55-7.22c-.24-.7-.36-1-.56-1.46h2.81c.05.38.16.85.29 1.3l1.74 5.77zM51.03 10.7c-.52-.06-.95-.08-1.98-.08h-3.78c-.91 0-1.25.01-1.76.04.07-.48.1-.92.1-1.75V2.35c0-.74-.02-1.16-.1-1.75.49.02.83.04 1.76.04h3.83c.82 0 1.22-.02 1.79-.08V2.8c-.55-.06-.98-.08-1.79-.08h-3.12v1.76h2.59c.79 0 1.08-.01 1.8-.08v2.22c-.56-.06-.97-.08-1.8-.08h-2.59v2.01h3.09c.91 0 1.44-.02 1.96-.08v2.24zM54.03 10.62c-.83 0-1.32.01-1.77.04.07-.42.1-.95.1-1.75V2.57c0-.84-.02-1.36-.1-1.93h2.61c-.08.62-.1.96-.1 1.9v5.95h2.9c1.02 0 1.43-.01 1.99-.08v2.3c-.44-.06-1.03-.08-1.99-.08h-3.65z"
								></path>
							</svg>
						</div>
					</div>
					<div className="hero-are-you">Character are you?</div>
				</div>
			</section>
		</>
	);
};

export default Hero;
